export default class ServerApi {
  constructor(config) {
    this._url = config.url;
    this._headers = config.headers;
  }

  // Проверка ответа
  _check(res) {
    if (res.ok) {
      return res.json();
    } else {
      return Promise.reject(`Ошибка: ${res.status}`);
    }
  }

  // Получение списка файлов
  getFiles(folder, path) {
    return fetch(`${this._url}/files?${folder}=${path}`, {
      method: "GET",
      headers: {
        ...this._headers,
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then(this._check) // Используем метод _check
      .catch((error) => {
        console.error("Ошибка получения файлов:", error);
        return null; // Возвращаем null при ошибке
      });
  }
  deleteFile(folder, path) {
    return fetch(`${this._url}/files/delete?${folder}=${path}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        return data;
      });
  }

  createFile(name, files, path) {
    return fetch(`${this._url}/files/create?${files}=${path}/${name}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        return data;
      });
  }
}

// Экспортируем экземпляр
export const vandalServer = new ServerApi({
  url: "https://vandalvisionteam-vandalvision-servernew-8cf3.twc1.net/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
